import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {MobileDelegateService} from '../../../core/services/mobile-delegate.service';
import {OnboardingV2Service} from '../../../core/services/onboarding-v2.service';
import { DelegateType } from '../../../shared/models/utility.model';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';
import {MobileWebViewService} from '../../../core/services/mobile-web-view.service';
import { StringHelper } from '../../../core/helpers/strings.helper';

@Component({
	selector: 'app-otp-modal-board-mobile',
	templateUrl: './otp-modal-board-mobile.component.html',
	styleUrls: ['./otp-modal-board-mobile.component.scss']
})
export class OtpModalBoardMobileComponent implements OnInit, OnDestroy {
	currentMode: string;
	readonly USSD_MODE = 'USSD_MODE';
	readonly SMS_MODE = 'SMS_MODE';
	ussdCode: string;
	countdown: any;
	loading: boolean;
	otpResponse: any;
	readonly countDownTime = 10;
	resendingOtp: boolean;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};
	canUseNewResendOtpUi = false;

	constructor(
		private modal: NzModalRef,
		private delegateService: MobileDelegateService,
		private onboardingService: OnboardingV2Service,
		private mobileService: MobileWebViewService) {
	}

	ngOnDestroy(): void {
		this.modal.componentInstance.callback({otpResponse: this.otpResponse, coundown: this.countdown});
	}

	ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.ussdCode = this.modal.componentInstance.data?.ussd;
		this.countdown = this.modal.componentInstance.data?.countdown;
		this.canUseNewResendOtpUi = this.modal.componentInstance.data?.canUseNewResendOtpUi;
		const isStartCountdown = this.isStartCountdown(this.countdown);
		if (isStartCountdown) {
			this.startCountDown();
		}
	}

	isStartCountdown(countdown) {
		if (countdown?.minutes > 0) {
			return true;
		}
		return countdown?.minutes === 0 && countdown?.seconds > 0;
	}

	handleGenerateOtpResponse(res) {
		this.otpResponse = res;
		this.countdown = this.countDownTime;
		if(this.canUseNewResendOtpUi){
			this.modal?.destroy()
			return
		}
		this.startCountDown();
		this.loading = false;
		this.resendingOtp = false;
	}

	generateOtpWithPhoneNumber() {
		if (this.resendingOtp) {
			return;
		}
		this.countdown = {minutes: 0, seconds: 0};
		this.resendingOtp = true;
		const phoneNumber = this.onboardingService.getSignupData()?.phoneNumber;
		const params = {phoneNumber};
		this.onboardingService.generateOTP(params).then(res => {
			this.handleGenerateOtpResponse(res);
		})
			.catch(error => {
				if (this.onboardingService.isSuspended(error)) {
					// Add implementation for Web
					this.handleOtpSuspension(error);
					return;
				}
				this.handleError(error)
				this.loading = false;
				this.resendingOtp = false;
			});
	}

	generateOtpWithToken() {
		if (this.resendingOtp) {
			return;
		}
		const token = this.onboardingService.getAccountActivationToken();
		this.onboardingService.validateAccountActivationToken(token)
		.then(res => {
			this.handleGenerateOtpResponse(res);
		})
			.catch(error => {
				if (this.onboardingService.isSuspended(error)) {
					this.handleOtpSuspension(error);
					return;
				}
				this.handleError(error)
				this.loading = false;
				this.resendingOtp = false;
			});
	}

	handleError(error) {
		const description = StringHelper.getErrorMessageHttpErrorResponse(error);
		this.onboardingService.launchErrorModal({description});
		this.resendingOtp = false;
	}

	handleOtpSuspension(error) {
		this.onboardingService.handleOtpSuspension(error);
		this.modal?.destroy();
		this.loading = false;
	}

	startCountDown() {
		const min = this.countdown?.minutes;
		const sec = this.countdown?.seconds;
		const totalMins = (sec / 60) + min;
		const startMinutes = totalMins || this.countDownTime;
		let time = startMinutes * 60;
		const t = setInterval(() => {
			const minutes = this.getMinutes(time);
			const seconds = this.getSeconds(time);
			this.countdown = {minutes, seconds};
			time--;
			if (minutes === 0 && seconds === 0) {
				clearInterval(t);
			}
		}, 1000);
	}

	getMinutes(time) {
		return Math.floor(time / 60);
	}

	getSeconds(time) {
		return Math.floor(time % 60);
	}

	formateTime = (t) => {
		return t < 10 ? '0' + t : t;
	}

	resendOTPViaSMS() {
		this.currentMode = this.SMS_MODE;
		const phoneNumber = this.onboardingService.getSignupData()?.phoneNumber;
		const activationToken = this.onboardingService.getAccountActivationToken();
		if(phoneNumber){
			this.generateOtpWithPhoneNumber();
			return
		}
		if(activationToken){
			this.generateOtpWithToken()
		}
	}

	resendOTPViaUssd() {
		this.currentMode = this.USSD_MODE;
		if (this.mobileService.isMobileWebViewUser()) {
			this.launchMobileDialer(this.ussdCode);
			return;
		}
		window.open(`tel:+${this.ussdCode}`);
	}

	launchMobileDialer(ussd) {
		this.delegateService.setDelegateData(DelegateType.launchDialer, ussd)
			.then(() => {
			})
			.catch(error => {
				window.open(`tel:+${this.ussdCode}`);
			});
	}


}
